type ToastType = 'success' | 'error' | 'info';

interface ToastOptions {
  duration?: number;
  closable?: boolean;
}

class ToastServiceClass {
  private listeners: Array<(message: string, type: ToastType, options?: ToastOptions) => void> = [];

  subscribe(callback: (message: string, type: ToastType, options?: ToastOptions) => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(l => l !== callback);
    };
  }

  show(message: string, type: ToastType = 'info', options?: ToastOptions) {
    this.listeners.forEach(listener => listener(message, type, options));
  }

  success(message: string, options?: ToastOptions) {
    this.show(message, 'success', options);
  }

  error(message: string, options?: ToastOptions) {
    this.show(message, 'error', options);
  }

  info(message: string, options?: ToastOptions) {
    this.show(message, 'info', options);
  }
}

export const ToastService = new ToastServiceClass();